// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─────────────────── Page Wrapper ─────────────────── */
.hc-page {
    display: flex;
    justify-content: center;
    padding: 24px 16px 72px;
}

.hc-container {
    width: 100%;
    max-width: 720px;
    display: flex;
    flex-direction: column;
    gap: 32px;
}

/* ─────────────────── Page Header ─────────────────── */
.hc-page-header {
    display: flex;
    align-items: center;
    gap: 16px;
}

.hc-header-icon-wrap {
    width: 56px;
    height: 56px;
    min-width: 56px;
    border-radius: 16px;
    background: rgba(59, 179, 174, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
}

.hc-header-icon {
    color: #48D1CC !important;
    font-size: 28px !important;
}

.hc-title {
    margin: 0;
    font-size: 24px;
    font-weight: 700;
    color: #ffffff;
    font-family: 'Inter', sans-serif;
}

.hc-subtitle {
    margin: 4px 0 0 0;
    color: #777;
    font-size: 14px;
    font-family: 'Inter', sans-serif;
    line-height: 1.5;
}

/* ─────────────────── Section ─────────────────── */
.hc-section {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.hc-section-title {
    margin: 0;
    font-size: 17px;
    font-weight: 700;
    color: #ffffff;
    font-family: 'Inter', sans-serif;
    letter-spacing: 0.01em;
}

.hc-section-subtitle {
    margin: -6px 0 0;
    color: #777;
    font-size: 13px;
    font-family: 'Inter', sans-serif;
    line-height: 1.6;
}

/* ─────────────────── Contact Card ─────────────────── */
.hc-contact-card {
    background-color: #0e1b1b;
    border-radius: 18px;
    border: 1px solid #484848;
    padding: 20px;
    display: flex;
    align-items: flex-start;
    gap: 16px;
    transition: border-color 0.2s ease, transform 0.2s ease;
}

.hc-contact-card:hover {
    border-color: #3BB3AE;
    transform: translateY(-2px);
}

.hc-contact-icon-wrap {
    width: 48px;
    height: 48px;
    min-width: 48px;
    border-radius: 14px;
    background: rgba(59, 179, 174, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
}

.hc-contact-icon {
    color: #3BB3AE !important;
    font-size: 24px !important;
}

.hc-contact-text {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.hc-contact-label {
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    font-family: 'Inter', sans-serif;
}

.hc-contact-email {
    font-size: 14px;
    font-weight: 500;
    color: #48D1CC;
    text-decoration: none;
    font-family: 'Inter', sans-serif;
    transition: opacity 0.2s;
}

.hc-contact-email:hover {
    opacity: 0.8;
    text-decoration: underline;
}

.hc-contact-desc {
    margin: 4px 0 0;
    color: #777;
    font-size: 13px;
    font-family: 'Inter', sans-serif;
    line-height: 1.5;
}

/* ─────────────────── Feedback Grid ─────────────────── */
.hc-feedback-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
}

.hc-fb-card {
    all: unset;
    cursor: pointer;
    background-color: #0e1b1b;
    border-radius: 16px;
    border: 1px solid #484848;
    padding: 18px 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    transition: transform 0.2s ease, border-color 0.2s ease, background-color 0.2s ease;
    box-sizing: border-box;
}

.hc-fb-card:hover {
    transform: translateY(-3px);
    border-color: #3BB3AE;
    background-color: #0a1414;
}

.hc-fb-card--active {
    border-color: #48D1CC !important;
    background-color: #071414 !important;
    box-shadow: 0 0 0 2px rgba(72, 209, 204, 0.2);
}

.hc-fb-icon-wrap {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    background: rgba(59, 179, 174, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
}

.hc-fb-icon {
    font-size: 22px !important;
    color: #3BB3AE !important;
}

.hc-fb-card-title {
    font-size: 15px;
    font-weight: 600;
    color: #ffffff;
    font-family: 'Inter', sans-serif;
}

.hc-fb-card-desc {
    font-size: 12px;
    color: #777;
    font-family: 'Inter', sans-serif;
    line-height: 1.5;
}

/* Feedback Textarea */
.hc-feedback-form {
    display: flex;
    flex-direction: column;
    gap: 10px;
    animation: hc-fade-in 0.2s ease;
}

.hc-feedback-textarea {
    width: 100%;
    background: #070F0F;
    border: 1px solid #484848;
    border-radius: 14px;
    color: #ffffff;
    font-size: 14px;
    font-family: 'Inter', sans-serif;
    padding: 14px 16px;
    resize: vertical;
    box-sizing: border-box;
    outline: none;
    transition: border-color 0.2s;
    line-height: 1.6;
}

.hc-feedback-textarea:focus {
    border-color: #3BB3AE;
}

.hc-feedback-textarea::placeholder {
    color: #484848;
}

.hc-feedback-submit {
    all: unset;
    cursor: pointer;
    align-self: flex-end;
    background: #3BB3AE;
    color: #070F0F;
    font-size: 14px;
    font-weight: 700;
    font-family: 'Inter', sans-serif;
    padding: 10px 28px;
    border-radius: 30px;
    transition: background 0.2s ease, transform 0.15s ease;
}

.hc-feedback-submit:hover {
    background: #48D1CC;
    transform: translateY(-1px);
}

/* ─────────────────── FAQ ─────────────────── */
.hc-faq-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.hc-faq-item {
    background-color: #0e1b1b;
    border-radius: 14px;
    border: 1px solid #484848;
    padding: 16px;
    cursor: pointer;
    transition: border-color 0.2s ease, background-color 0.2s ease;
}

.hc-faq-item:hover {
    border-color: #3BB3AE;
    background-color: #0a1414;
}

.hc-faq-item--open {
    border-color: #3BB3AE;
    background-color: #071414;
}

.hc-faq-question {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    font-size: 15px;
    font-weight: 600;
    color: #ffffff;
    font-family: 'Inter', sans-serif;
    -webkit-user-select: none;
            user-select: none;
}

.hc-faq-chevron {
    color: #3BB3AE !important;
    font-size: 20px !important;
    flex-shrink: 0;
    transition: transform 0.2s ease;
}

.hc-faq-answer {
    margin-top: 12px;
    font-size: 13px;
    color: #777;
    font-family: 'Inter', sans-serif;
    line-height: 1.7;
    animation: hc-fade-in 0.18s ease;
}

/* ─────────────────── Terms & Policies ─────────────────── */
.hc-policies-section {
    background-color: #0e1b1b;
    border-radius: 18px;
    border: 1px solid #484848;
    padding: 24px 20px;
}

.hc-policies-buttons {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
}

.hc-policy-btn {
    all: unset;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: rgba(59, 179, 174, 0.1);
    color: #48D1CC;
    border: 1px solid #3BB3AE;
    border-radius: 30px;
    padding: 10px 22px;
    font-size: 14px;
    font-weight: 600;
    font-family: 'Inter', sans-serif;
    transition: background 0.2s ease, transform 0.15s ease;
}

.hc-policy-btn:hover {
    background: #3BB3AE;
    color: #070F0F;
    transform: translateY(-2px);
}

.hc-policy-btn--secondary {
    background: transparent;
    color: #3BB3AE;
    border-color: #484848;
}

.hc-policy-btn--secondary:hover {
    background: #3BB3AE;
    color: #070F0F;
    border-color: #3BB3AE;
}

.hc-policy-btn-icon {
    font-size: 18px !important;
}

.hc-feedback-submit:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
}

.hc-form-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
}

.hc-feedback-cancel {
    all: unset;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    font-family: 'Inter', sans-serif;
    color: #777;
    padding: 10px 20px;
    border-radius: 30px;
    border: 1px solid #484848;
    transition: color 0.2s ease, border-color 0.2s ease;
}

.hc-feedback-cancel:hover {
    color: #ffffff;
    border-color: #777;
}

.hc-feedback-cancel:disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

/* Status messages */
.hc-submit-status {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 500;
    font-family: 'Inter', sans-serif;
    padding: 10px 14px;
    border-radius: 10px;
    animation: hc-fade-in 0.2s ease;
}

.hc-submit-status--success {
    background: rgba(59, 179, 174, 0.12);
    border: 1px solid rgba(59, 179, 174, 0.3);
    color: #3BB3AE;
}

.hc-submit-status--error {
    background: rgba(239, 68, 68, 0.1);
    border: 1px solid rgba(239, 68, 68, 0.3);
    color: #f87171;
}

/* ─────────────────── Screenshot Upload ─────────────────── */
.hc-upload-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 600;
    color: #ffffff;
    font-family: 'Inter', sans-serif;
}

.hc-upload-optional {
    font-size: 11px;
    font-weight: 500;
    color: #3BB3AE;
    background: rgba(59, 179, 174, 0.12);
    border: 1px solid rgba(59, 179, 174, 0.3);
    border-radius: 20px;
    padding: 2px 8px;
    letter-spacing: 0.03em;
}

.hc-drop-zone {
    width: 100%;
    box-sizing: border-box;
    border: 1.5px dashed #484848;
    border-radius: 14px;
    background: #070F0F;
    padding: 24px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    cursor: pointer;
    transition: border-color 0.2s ease, background-color 0.2s ease;
}

.hc-drop-zone:hover {
    border-color: #3BB3AE;
    background-color: #0a1414;
}

.hc-drop-zone--over {
    border-color: #48D1CC;
    background-color: rgba(59, 179, 174, 0.08);
}

.hc-drop-icon {
    color: #3BB3AE !important;
    font-size: 32px !important;
}

.hc-drop-text {
    font-size: 13px;
    font-weight: 500;
    color: #ffffff;
    font-family: 'Inter', sans-serif;
}

.hc-drop-hint {
    font-size: 11px;
    color: #777;
    font-family: 'Inter', sans-serif;
}

/* Preview */
.hc-screenshot-preview {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #3BB3AE;
    border-radius: 14px;
    overflow: hidden;
    background: #070F0F;
}

.hc-screenshot-img {
    width: 100%;
    max-height: 200px;
    object-fit: contain;
    display: block;
    border-radius: 13px;
}

.hc-screenshot-remove {
    all: unset;
    cursor: pointer;
    position: absolute;
    top: 8px;
    right: 8px;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.7);
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s ease;
}

.hc-screenshot-remove:hover {
    background: rgba(239, 68, 68, 0.85);
}

/* ─────────────────── Animation ─────────────────── */
@keyframes hc-fade-in {
    from { opacity: 0; transform: translateY(4px); }
    to   { opacity: 1; transform: translateY(0); }
}

/* ─────────────────── Responsive ─────────────────── */
@media (max-width: 520px) {
    .hc-feedback-grid {
        grid-template-columns: 1fr;
    }

    .hc-title {
        font-size: 20px;
    }

    .hc-page-header {
        gap: 12px;
    }

    .hc-policies-buttons {
        flex-direction: column;
    }

    .hc-policy-btn {
        justify-content: center;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/HelpCenter/HelpCenter.css"],"names":[],"mappings":"AAAA,yDAAyD;AACzD;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA,wDAAwD;AACxD;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA,oDAAoD;AACpD;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA,yDAAyD;AACzD;IACI,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,uDAAuD;AAC3D;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,gCAAgC;IAChC,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;IACf,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA,0DAA0D;AAC1D;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,UAAU;IACV,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mFAAmF;IACnF,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,oCAAoC;IACpC,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,mBAAmB;IACnB,sDAAsD;AAC1D;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA,gDAAgD;AAChD;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,eAAe;IACf,8DAA8D;AAClE;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gCAAgC;IAChC,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,gCAAgC;IAChC,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA,6DAA6D;AAC7D;IACI,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mCAAmC;IACnC,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,sDAAsD;AAC1D;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,mDAAmD;AACvD;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,oCAAoC;IACpC,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,wCAAwC;IACxC,cAAc;AAClB;;AAEA,8DAA8D;AAC9D;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oCAAoC;IACpC,yCAAyC;IACzC,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,4BAA4B;IAC5B,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,8DAA8D;AAClE;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gCAAgC;AACpC;;AAEA,YAAY;AACZ;IACI,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,mCAAmC;AACvC;;AAEA,sDAAsD;AACtD;IACI,OAAO,UAAU,EAAE,0BAA0B,EAAE;IAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AACjD;;AAEA,uDAAuD;AACvD;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;AACJ","sourcesContent":["/* ─────────────────── Page Wrapper ─────────────────── */\n.hc-page {\n    display: flex;\n    justify-content: center;\n    padding: 24px 16px 72px;\n}\n\n.hc-container {\n    width: 100%;\n    max-width: 720px;\n    display: flex;\n    flex-direction: column;\n    gap: 32px;\n}\n\n/* ─────────────────── Page Header ─────────────────── */\n.hc-page-header {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.hc-header-icon-wrap {\n    width: 56px;\n    height: 56px;\n    min-width: 56px;\n    border-radius: 16px;\n    background: rgba(59, 179, 174, 0.15);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.hc-header-icon {\n    color: #48D1CC !important;\n    font-size: 28px !important;\n}\n\n.hc-title {\n    margin: 0;\n    font-size: 24px;\n    font-weight: 700;\n    color: #ffffff;\n    font-family: 'Inter', sans-serif;\n}\n\n.hc-subtitle {\n    margin: 4px 0 0 0;\n    color: #777;\n    font-size: 14px;\n    font-family: 'Inter', sans-serif;\n    line-height: 1.5;\n}\n\n/* ─────────────────── Section ─────────────────── */\n.hc-section {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n}\n\n.hc-section-title {\n    margin: 0;\n    font-size: 17px;\n    font-weight: 700;\n    color: #ffffff;\n    font-family: 'Inter', sans-serif;\n    letter-spacing: 0.01em;\n}\n\n.hc-section-subtitle {\n    margin: -6px 0 0;\n    color: #777;\n    font-size: 13px;\n    font-family: 'Inter', sans-serif;\n    line-height: 1.6;\n}\n\n/* ─────────────────── Contact Card ─────────────────── */\n.hc-contact-card {\n    background-color: #0e1b1b;\n    border-radius: 18px;\n    border: 1px solid #484848;\n    padding: 20px;\n    display: flex;\n    align-items: flex-start;\n    gap: 16px;\n    transition: border-color 0.2s ease, transform 0.2s ease;\n}\n\n.hc-contact-card:hover {\n    border-color: #3BB3AE;\n    transform: translateY(-2px);\n}\n\n.hc-contact-icon-wrap {\n    width: 48px;\n    height: 48px;\n    min-width: 48px;\n    border-radius: 14px;\n    background: rgba(59, 179, 174, 0.15);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.hc-contact-icon {\n    color: #3BB3AE !important;\n    font-size: 24px !important;\n}\n\n.hc-contact-text {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.hc-contact-label {\n    font-size: 16px;\n    font-weight: 600;\n    color: #ffffff;\n    font-family: 'Inter', sans-serif;\n}\n\n.hc-contact-email {\n    font-size: 14px;\n    font-weight: 500;\n    color: #48D1CC;\n    text-decoration: none;\n    font-family: 'Inter', sans-serif;\n    transition: opacity 0.2s;\n}\n\n.hc-contact-email:hover {\n    opacity: 0.8;\n    text-decoration: underline;\n}\n\n.hc-contact-desc {\n    margin: 4px 0 0;\n    color: #777;\n    font-size: 13px;\n    font-family: 'Inter', sans-serif;\n    line-height: 1.5;\n}\n\n/* ─────────────────── Feedback Grid ─────────────────── */\n.hc-feedback-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 12px;\n}\n\n.hc-fb-card {\n    all: unset;\n    cursor: pointer;\n    background-color: #0e1b1b;\n    border-radius: 16px;\n    border: 1px solid #484848;\n    padding: 18px 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    transition: transform 0.2s ease, border-color 0.2s ease, background-color 0.2s ease;\n    box-sizing: border-box;\n}\n\n.hc-fb-card:hover {\n    transform: translateY(-3px);\n    border-color: #3BB3AE;\n    background-color: #0a1414;\n}\n\n.hc-fb-card--active {\n    border-color: #48D1CC !important;\n    background-color: #071414 !important;\n    box-shadow: 0 0 0 2px rgba(72, 209, 204, 0.2);\n}\n\n.hc-fb-icon-wrap {\n    width: 40px;\n    height: 40px;\n    border-radius: 12px;\n    background: rgba(59, 179, 174, 0.15);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.hc-fb-icon {\n    font-size: 22px !important;\n    color: #3BB3AE !important;\n}\n\n.hc-fb-card-title {\n    font-size: 15px;\n    font-weight: 600;\n    color: #ffffff;\n    font-family: 'Inter', sans-serif;\n}\n\n.hc-fb-card-desc {\n    font-size: 12px;\n    color: #777;\n    font-family: 'Inter', sans-serif;\n    line-height: 1.5;\n}\n\n/* Feedback Textarea */\n.hc-feedback-form {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    animation: hc-fade-in 0.2s ease;\n}\n\n.hc-feedback-textarea {\n    width: 100%;\n    background: #070F0F;\n    border: 1px solid #484848;\n    border-radius: 14px;\n    color: #ffffff;\n    font-size: 14px;\n    font-family: 'Inter', sans-serif;\n    padding: 14px 16px;\n    resize: vertical;\n    box-sizing: border-box;\n    outline: none;\n    transition: border-color 0.2s;\n    line-height: 1.6;\n}\n\n.hc-feedback-textarea:focus {\n    border-color: #3BB3AE;\n}\n\n.hc-feedback-textarea::placeholder {\n    color: #484848;\n}\n\n.hc-feedback-submit {\n    all: unset;\n    cursor: pointer;\n    align-self: flex-end;\n    background: #3BB3AE;\n    color: #070F0F;\n    font-size: 14px;\n    font-weight: 700;\n    font-family: 'Inter', sans-serif;\n    padding: 10px 28px;\n    border-radius: 30px;\n    transition: background 0.2s ease, transform 0.15s ease;\n}\n\n.hc-feedback-submit:hover {\n    background: #48D1CC;\n    transform: translateY(-1px);\n}\n\n/* ─────────────────── FAQ ─────────────────── */\n.hc-faq-list {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.hc-faq-item {\n    background-color: #0e1b1b;\n    border-radius: 14px;\n    border: 1px solid #484848;\n    padding: 16px;\n    cursor: pointer;\n    transition: border-color 0.2s ease, background-color 0.2s ease;\n}\n\n.hc-faq-item:hover {\n    border-color: #3BB3AE;\n    background-color: #0a1414;\n}\n\n.hc-faq-item--open {\n    border-color: #3BB3AE;\n    background-color: #071414;\n}\n\n.hc-faq-question {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    font-size: 15px;\n    font-weight: 600;\n    color: #ffffff;\n    font-family: 'Inter', sans-serif;\n    user-select: none;\n}\n\n.hc-faq-chevron {\n    color: #3BB3AE !important;\n    font-size: 20px !important;\n    flex-shrink: 0;\n    transition: transform 0.2s ease;\n}\n\n.hc-faq-answer {\n    margin-top: 12px;\n    font-size: 13px;\n    color: #777;\n    font-family: 'Inter', sans-serif;\n    line-height: 1.7;\n    animation: hc-fade-in 0.18s ease;\n}\n\n/* ─────────────────── Terms & Policies ─────────────────── */\n.hc-policies-section {\n    background-color: #0e1b1b;\n    border-radius: 18px;\n    border: 1px solid #484848;\n    padding: 24px 20px;\n}\n\n.hc-policies-buttons {\n    display: flex;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.hc-policy-btn {\n    all: unset;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    background: rgba(59, 179, 174, 0.1);\n    color: #48D1CC;\n    border: 1px solid #3BB3AE;\n    border-radius: 30px;\n    padding: 10px 22px;\n    font-size: 14px;\n    font-weight: 600;\n    font-family: 'Inter', sans-serif;\n    transition: background 0.2s ease, transform 0.15s ease;\n}\n\n.hc-policy-btn:hover {\n    background: #3BB3AE;\n    color: #070F0F;\n    transform: translateY(-2px);\n}\n\n.hc-policy-btn--secondary {\n    background: transparent;\n    color: #3BB3AE;\n    border-color: #484848;\n}\n\n.hc-policy-btn--secondary:hover {\n    background: #3BB3AE;\n    color: #070F0F;\n    border-color: #3BB3AE;\n}\n\n.hc-policy-btn-icon {\n    font-size: 18px !important;\n}\n\n.hc-feedback-submit:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    transform: none;\n}\n\n.hc-form-footer {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 10px;\n}\n\n.hc-feedback-cancel {\n    all: unset;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 600;\n    font-family: 'Inter', sans-serif;\n    color: #777;\n    padding: 10px 20px;\n    border-radius: 30px;\n    border: 1px solid #484848;\n    transition: color 0.2s ease, border-color 0.2s ease;\n}\n\n.hc-feedback-cancel:hover {\n    color: #ffffff;\n    border-color: #777;\n}\n\n.hc-feedback-cancel:disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n}\n\n/* Status messages */\n.hc-submit-status {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 13px;\n    font-weight: 500;\n    font-family: 'Inter', sans-serif;\n    padding: 10px 14px;\n    border-radius: 10px;\n    animation: hc-fade-in 0.2s ease;\n}\n\n.hc-submit-status--success {\n    background: rgba(59, 179, 174, 0.12);\n    border: 1px solid rgba(59, 179, 174, 0.3);\n    color: #3BB3AE;\n}\n\n.hc-submit-status--error {\n    background: rgba(239, 68, 68, 0.1);\n    border: 1px solid rgba(239, 68, 68, 0.3);\n    color: #f87171;\n}\n\n/* ─────────────────── Screenshot Upload ─────────────────── */\n.hc-upload-label {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 13px;\n    font-weight: 600;\n    color: #ffffff;\n    font-family: 'Inter', sans-serif;\n}\n\n.hc-upload-optional {\n    font-size: 11px;\n    font-weight: 500;\n    color: #3BB3AE;\n    background: rgba(59, 179, 174, 0.12);\n    border: 1px solid rgba(59, 179, 174, 0.3);\n    border-radius: 20px;\n    padding: 2px 8px;\n    letter-spacing: 0.03em;\n}\n\n.hc-drop-zone {\n    width: 100%;\n    box-sizing: border-box;\n    border: 1.5px dashed #484848;\n    border-radius: 14px;\n    background: #070F0F;\n    padding: 24px 16px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    cursor: pointer;\n    transition: border-color 0.2s ease, background-color 0.2s ease;\n}\n\n.hc-drop-zone:hover {\n    border-color: #3BB3AE;\n    background-color: #0a1414;\n}\n\n.hc-drop-zone--over {\n    border-color: #48D1CC;\n    background-color: rgba(59, 179, 174, 0.08);\n}\n\n.hc-drop-icon {\n    color: #3BB3AE !important;\n    font-size: 32px !important;\n}\n\n.hc-drop-text {\n    font-size: 13px;\n    font-weight: 500;\n    color: #ffffff;\n    font-family: 'Inter', sans-serif;\n}\n\n.hc-drop-hint {\n    font-size: 11px;\n    color: #777;\n    font-family: 'Inter', sans-serif;\n}\n\n/* Preview */\n.hc-screenshot-preview {\n    position: relative;\n    width: 100%;\n    box-sizing: border-box;\n    border: 1px solid #3BB3AE;\n    border-radius: 14px;\n    overflow: hidden;\n    background: #070F0F;\n}\n\n.hc-screenshot-img {\n    width: 100%;\n    max-height: 200px;\n    object-fit: contain;\n    display: block;\n    border-radius: 13px;\n}\n\n.hc-screenshot-remove {\n    all: unset;\n    cursor: pointer;\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    width: 26px;\n    height: 26px;\n    border-radius: 50%;\n    background: rgba(0, 0, 0, 0.7);\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.2s ease;\n}\n\n.hc-screenshot-remove:hover {\n    background: rgba(239, 68, 68, 0.85);\n}\n\n/* ─────────────────── Animation ─────────────────── */\n@keyframes hc-fade-in {\n    from { opacity: 0; transform: translateY(4px); }\n    to   { opacity: 1; transform: translateY(0); }\n}\n\n/* ─────────────────── Responsive ─────────────────── */\n@media (max-width: 520px) {\n    .hc-feedback-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .hc-title {\n        font-size: 20px;\n    }\n\n    .hc-page-header {\n        gap: 12px;\n    }\n\n    .hc-policies-buttons {\n        flex-direction: column;\n    }\n\n    .hc-policy-btn {\n        justify-content: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
